export default __webpack_public_path__ + "static/media/diamond_grid.8def3ca8.svg";